class DlPopHsaFsa extends DlPopBaseH {
    connectedCallback() {
        super.connectedCallback();
        this._ac = new AbortController();
        this.querySelector('.dl-product-info-h-benifit-content-item-button')
            ?.addEventListener('click', () => this.hide(), { signal: this._ac.signal });
    }

    disconnectedCallback() {
        this._ac?.abort();
    }
}
customElements.define('dl-pop-hsa-fsa', DlPopHsaFsa);

class DlProductBenifitItemM extends HTMLElement {
    connectedCallback() {
        this._ac = new AbortController();

        // HSA/FSA 弹窗按钮
        if (this.hasAttribute('data-dl-hsa-fsa-trigger') && this.querySelector('.dl-product-info-h-benifit-item-button')) {
            this.addEventListener('click', () => {
                this._pop ??= this.parentElement?.querySelector('dl-pop-hsa-fsa');
                this._pop?.show();
                try {
                    const name = this.textContent;
                    if (name) {
                        DLPixelH.capture('pdp_benefit_click', {
                            name: name
                        });
                    }
                } catch (error) {
                    console.error('Error:', error);
                }
            }, { signal: this._ac.signal });
        }
        // Protection item：点击整个 item 触发对应弹窗（与 header 点击一致）
        if (this.hasAttribute('data-dl-pp-trigger')) {
            this.addEventListener('click', () => {
                const scopeRoot = this.closest('dl-product-h') || document;
                const selectedMain = scopeRoot.querySelector('.dl-product-purchase-protection-ll.dl-selected');
                selectedMain
                    ?.closest('dl-product-purchase-protection-ll')
                    ?.pop();
                try {
                    const name = this.textContent;
                    if (name) {
                        DLPixelH.capture('pdp_benefit_click', {
                            name: name
                        });
                    }
                } catch (error) {
                    console.error('Error:', error);
                }
            }, { signal: this._ac.signal });
        }
    }

    disconnectedCallback() {
        this._ac?.abort();
        this._pop = null;
    }
}
customElements.define('dl-product-benifit-item-m', DlProductBenifitItemM);
